// extracted by mini-css-extract-plugin
module.exports = {"navContent":"Navigation_navContent__2G7jX","flexAction":"Navigation_flexAction__1zq4w","text":"Navigation_text__3NQCE","flexText":"Navigation_flexText__1Tw7W"};